import { PayRoll, PayRollBatch } from '@models';

export interface PayRollState {
  currentPayRoll: PayRoll | null;
  currentPayRollBatch: PayRollBatch | null;
  payRollBatches: PayRollBatch[];
  fetchedAt: Date | null;
}

export const initialPayRollState: PayRollState = {
  currentPayRoll: null,
  currentPayRollBatch: null,
  payRollBatches: [],
  fetchedAt: null,
};
